import script from "./CollectionAnalyticsField.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionAnalyticsField.vue?vue&type=script&setup=true&lang=js"

export default script